/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransportStep
 */
export interface TransportStep {
    /**
     * 
     * @type {number}
     * @memberof TransportStep
     */
    distance?: number;
    /**
     * 
     * @type {number}
     * @memberof TransportStep
     */
    duration?: number;
}

export function TransportStepFromJSON(json: any): TransportStep {
    return TransportStepFromJSONTyped(json, false);
}

export function TransportStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportStep {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'distance': !exists(json, 'distance') ? undefined : json['distance'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
    };
}

export function TransportStepToJSON(value?: TransportStep | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'distance': value.distance,
        'duration': value.duration,
    };
}


